import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getGeneCardData } from "../../../../state/selectors/CardsUI.selectors";
import IconExternalLink from "../../../../../../assets/images/svg/external-link.svg";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getVarsomeHost,
  getGenomeName,
} from "../../../../state/selectors/general.selectors";

const GeneCard = ({ card, genesInfo, varsomeHost, genome }) => {
  const isDisabled = !genesInfo || genesInfo.cardContent.length < 1;
  return (
    <CardWrapper {...card} card={card} isDisabled={isDisabled}>
      {genesInfo && genesInfo.cardContent.length > 0 ? (
        <ul className="tw-flex tw-m-0 tw-p-0 tw-list-none">
          {genesInfo.cardContent.map((gene, index) => (
            <li key={gene}>
              <a
                tabIndex={-1}
                target="_blank"
                className="tw-flex tw-items-center"
                href={`${varsomeHost}/gene/${genome}/${gene}`}
              >
                {index === 0 ? (
                  <b data-testid="basic-gene-value">{gene}</b>
                ) : (
                  gene
                )}
                <IconExternalLink className="tw-w-3 tw-h-3 tw-ml-0.5 tw-mr-2" />
              </a>
            </li>
          ))}
          {genesInfo.componentContent &&
            genesInfo.componentContent.length > 0 && (
              <li
                className="tw-font-normal tw-italic"
                data-testid="secondary-gene-value"
              >
                ( +{genesInfo.componentContent.length} more)
              </li>
            )}
        </ul>
      ) : null}
    </CardWrapper>
  );
};

GeneCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  genesInfo: PropTypes.shape({
    componentContent: PropTypes.arrayOf(
      PropTypes.shape({ symbol: PropTypes.string })
    ),
    cardContent: PropTypes.arrayOf(PropTypes.string),
  }),
  varsomeHost: PropTypes.string,
  genome: PropTypes.string,
};

GeneCard.defaultProps = {
  genesInfo: {},
  varsomeHost: null,
  genome: null,
};

const mapStateToProps = (state) => ({
  genesInfo: getGeneCardData(state),
  varsomeHost: getVarsomeHost(state),
  genome: getGenomeName(state),
});

export default connect(mapStateToProps)(GeneCard);
